import React, { useState } from "react";
import { call_icon } from "../../../icons/call";
import { copy_icon } from "../../../icons/copy";

const SupervisorModal = ({ setShowSupervisor, auction }) => {
  const [copy, setCopy] = useState(true);
  return (
    <>
      <div className="">
        <div className="text-right  font-bold text-lg mb-6">تفاصيل المزاد</div>
        <div className="w-[80%] mx-auto">
          <div className="flex flex-row justify-between items-center"></div>
          <p className="font-bold lg:text-2xl text-primary text-center my-5">
            الرجاء التواصل مع مشرف المزاد
          </p>
          <div className="flex flex-col  h-full  items-center">
            <div className="flex flex-col w-full items-center lg:px-20 font-bold">
              <div className="text-lg ml-auto">مشرف المزاد</div>
              <div className="h-5" />
              <div className="flex flex-col lg:flex-row-reverse justify-between items-center w-full font-semibold">
                <p className="text-center mb-6 lg:mb-0">
                  {auction._supervisor.name}
                  
                </p>

                <div className="flex flex-row-reverse items-center justify-center gap-8">
                  <p className="text-primary text-xl">
                    {auction._supervisor.phonenumber}
                  </p>
                  <div className="flex justify-center items-center flex-row-reverse gap-2">
                    <a href={`tel:${auction._supervisor.phonenumber} `}>
                      {call_icon}
                    </a>

                    <button
                      onClick={() => {
                        navigator.clipboard.writeText();
                        setCopy(false);
                      }}
                    >
                      {copy === true && <span>{copy_icon}</span>}
                      {copy === false && (
                        <span dir="rtl" className="text-primary ">
                          تم النسخ !
                        </span>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full  lg:px-20">
              <p
                dir="rtl"
                className="text-black font-bold text-lg list-item h-auto   my-6"
              >
                يتم قبول طلب الدخول بعد دفع مبلغ الأمنية لمشرف المزاد
              </p>
            </div>

            <div className="h-1" />

            <div className="lg:w-[531px] h-[46px] my-6 w-full bg-primary rounded-2xl text-white font-bold flex justify-center items-center">
              {" "}
              ... طلب الدخول قيد المعاينة
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SupervisorModal;
